import React from 'react';
import { useParams } from 'react-router-dom';
import { Table, Spin } from 'antd';
import { getHousesWithCameraTableColumns } from './utils/getHousesWithCameraTableColumns';
import useTablePagination from '../../../../hooks/useTablePagination';
import { generateAddress } from '../../../../utils/generateAddress';
import useFilteredBySearchData from '../../../../hooks/useFilteredBySearchData';
import useTableChange from '../../../../hooks/useTableChange';
import { sortableColumnsData } from '../constants/sortableColumnsData';
import useHousesWithCamera from '../../../../queries/useHousesWithCamera';
import { housesWithCameraTableComponents } from './constants/housesWithcameraTableComponents';
import { modes } from '../../MainHeader/components/Search';
import styles from './HouseWithCameraTable.module.scss';

const { Column } = Table;

const HousesWithCameraTable = ({ onRowClick, pagination = true, ...props }) => {
  const { companyId } = useParams();

  const { data: housesWithCamera, isFetching: isHousesWithCameraFetching } =
    useHousesWithCamera(companyId, {
      enabled: Boolean(companyId),
      staleTime: Infinity,
    });

  const [loading, filteredBySearchHouses] = useFilteredBySearchData({
    data: housesWithCamera,
    key: generateAddress,
    mode: modes.houses,
  });

  const {
    data: sortedHouses,
    sortedInfo,
    handleTableChange,
  } = useTableChange({
    initialData: filteredBySearchHouses,
    sortableColumnKeys: sortableColumnsData,
    depsToReset: [companyId],
  });

  const { shownItems: shownHouses, pagination: paginationBlock } =
    useTablePagination(sortedHouses);

  return (
    <Spin spinning={loading}>
      <Table
        {...props}
        loading={isHousesWithCameraFetching}
        dataSource={pagination ? shownHouses : sortedHouses}
        components={housesWithCameraTableComponents}
        rowKey={(record) => record.id}
        pagination={false}
        onChange={handleTableChange}
        rowClassName={styles.row}
      >
        {getHousesWithCameraTableColumns({
          sortedInfo,
        }).map((column) => {
          return <Column {...column} />;
        })}
      </Table>
      {pagination && paginationBlock}
    </Spin>
  );
};

export default HousesWithCameraTable;
